export const appNameInterceptor = config => {
	return {
		...config,
		headers: {
			...(config.headers || {}),
			'x-application-name': 'Unite',
		},
	};
};
